import React, { useState, FormEvent,useEffect, use, useContext } from 'react';
import axios from 'axios';
import { useNavigate, useLocation } from 'react-router-dom'

import {ipAdress, getRouteSetterInfo, getRouteSetterGymFilterInfo, getTagListInfo, hasAdditionnalDifficultySystem, getRouteSetterGymFilterInfoSpecific} from '../data/getAxiosRequests'
import NavBarBackOffice from '../components/backOffice/Navbar';
import { GymMinimalProps, RouteSetterAllRouteInfoProps, SectorExtraMinimalProps,RouteSetterProps, Status, TagsList, GymDifficultySystemMinimalProps, SectorMinimalProps, Level } from '../constants/types';
import CheckMarkButton from '../components/UI/CheckMarkButton';
import ColorSquare from '../components/UI/ColorSquare';
import DifficultySvg from '../components/UI/DifficultySvg';
import LevelSelector from '../components/backOffice/LevelSelector';
import { Levels, pages } from '../constants/Consts';
import RouteRow from '../components/backOffice/RouteRow';
import { handleItemClick, handleCheckToggle, handleSorting } from '../constants/helpers';
import { SVGs } from '../constants/Svgs';
import CustomButtonSort from '../components/UI/CustomButtonSort';
import CustomButtonBO from '../components/UI/CustomButtonBO';
import CustomButton from '../components/UI/CustomButton';
import { GlobalContext } from '../context/GlobalStateProvider';

const PAGE_SIZE = 50;

const SkeletonBlock: React.FC<{ className?: string }> = ({ className = '' }) => (
    <div className={`bg-grey-200 rounded-lg animate-pulse ${className}`} />
);

const BoulderTableSkeleton: React.FC = () => (
    <div className="pannels-filter__filters" style={{gap:0, marginTop:'12px'}}>
        <SkeletonBlock className="h-6 w-64" />
        <SkeletonBlock className="h-4 w-96 mt-2" />
        <div className="flex flex-col gap-2 mt-4 w-full">
            <SkeletonBlock className="h-10 w-full rounded-md" />
            <SkeletonBlock className="h-10 w-full rounded-md" />
            <SkeletonBlock className="h-10 w-full rounded-md" />
            <SkeletonBlock className="h-10 w-full rounded-md" />
            <SkeletonBlock className="h-10 w-full rounded-md" />
            <SkeletonBlock className="h-10 w-full rounded-md" />
            <SkeletonBlock className="h-10 w-full rounded-md" />
            <SkeletonBlock className="h-10 w-full rounded-md" />
        </div>
    </div>
);


const BackOfficeMainPage: React.FC = () => {
    const navigate = useNavigate()
    const location = useLocation();
    const globalContext = useContext(GlobalContext);
    const { currentGym, setCurrentGym,user,setCurrentPage,routeSetterInfo } = globalContext;

    const [routesInfo, setRoutesInfo] = useState<RouteSetterAllRouteInfoProps | undefined>(undefined);
    const [shouldBeLoading, setShouldBeLoading] = useState(true)
    const [gymsFilterInfo, setGymsFilterInfo] = useState<GymMinimalProps[] | undefined >([])
    const [additionnalDifficultySystem, setAdditionnalDifficultySystem] = useState(false)
    const [difficultyList, setDifficultyList] = useState <GymDifficultySystemMinimalProps[] |undefined> ([])
    const [sectorsList, setSectorsList] = useState <SectorExtraMinimalProps[] |undefined> ([])
    const [tagsList, setTagsList] = useState<TagsList | undefined >(undefined)
    const levelList :Level[] = Object.values(Levels)
    const [checkGymAllFilters, setCheckGymAllFilters] = useState(true)
    const [checkColorsAllFilters,setCheckColorsAllFilters] = useState(true)
    const [checkDifficultyAllFilters,setCheckDifficultyAllFilters] = useState(true)
    const [checkLevelAllFilters, setCheckLevelAllFilters] = useState(true)
    const [checkSectorsAllFilters,setCheckSectorsAllFilters] = useState(true)
    const [checkTagsInclinaisonAllFilters, setCheckTagsInclinaisonAllFilters] = useState(true)
    const [checkTagsPrisesAllFilters, setCheckTagsPrisesAllFilters] = useState(true)
    const [checkTagsMovementAllFilters, setCheckTagsMovementAllFilters]= useState(true)
    const [checkStatusAllFilters, setCheckStatusAllFilters] = useState(true)
    const [clickedGyms, setClickedGyms] = useState({});
    const [clickedTagsSteepness, setClickedTagsSteepness] = useState({})
    const [clickedTagsGrips, setClickedTagsGrips] = useState({})
    const [clickedTagsStyle, setClickedTagsStyle] = useState({})
    const [clickedColors, setClickedColors] = useState({});
    const [clickedStatus, setClickedStatus] = useState({})
    const [clickedDifficulties, setClickedDifficulties] = useState({});
    const [clickedLevels, setClickedLevels] = useState({})
    const [clickedSectors, setClickedSectors] = useState({});
    const [currentPageNum, setCurrentPageNum] = useState(1)
    const [filteredGyms, setFilteredGyms]=useState([0])
    const [filteredTagsSteepness, setFilteredTagsSteepness]=useState([0])
    const [filteredTagsGrips, setFilteredTagsGrips]=useState([0])
    const [filteredTagsStyle, setFilteredTagsStyle]=useState([0])
    const [filteredStatus, setFilteredStatus]=useState([0])
    const [filteredDifficulties, setFilteredDifficulties]=useState([0])
    const [filteredLevels, setFilteredLevels]=useState([0])
    const [filteredSectors, setFilteredSectors]=useState([0])
    const [sortGyms, setSortGyms] = useState(0)
    const [sortStatus, setSortStatus] = useState(0)
    const [sortDifficulties, setSortDifficulties] = useState(0)
    const [sortLevels, setSortLevels] = useState(0)
    const [sortSectors, setSortSectors] = useState(0)
    const [sortName, setSortName] = useState(0)
    const [sortDate, setSortDate] = useState(2)
    const [sortColor, setSortColor] = useState(0)
    const [difficultySummary, setDifficultySummary] = useState([])
    const [totalRoutesCount, setTotalRoutesCount] = useState(0);
    const [areFiltersOpened, setAreFiltersOpened] = useState(true)
    const [disableClick, setDisableClick]= useState(false)


    useEffect(() => {
        setCurrentPage(pages.detailBlocs)
    }, []);

    useEffect(() => {
        if(currentGym){
            setFilteredGyms([currentGym.id])
        }
        else{
            const favoriteGym = localStorage.getItem('favoriteGymInfo');
            setCurrentGym(JSON.parse(favoriteGym));
        }
    }, []);

    useEffect(() => {
        if(currentGym){
            setFilteredGyms([currentGym.id])
        }
    }, [currentGym]);


    const sortSetters = {
        sortGyms: setSortGyms,
        sortStatus: setSortStatus,
        sortDifficulties: setSortDifficulties,
        sortLevels: setSortLevels,
        sortSectors: setSortSectors,
        sortName: setSortName,
        sortDate: setSortDate
    }




    const statusList: Status[] = [
        {
            id: 1,
            status: 'Actif'
        },
        {
            id: 2,
            status: 'Fermé'
        }
    ];

    const totalPages = Math.ceil(totalRoutesCount / PAGE_SIZE);

    const goToPage = (page: number) => {
        if (page < 1 || page > totalPages || page === currentPageNum) return;
        setDisableClick(true);
        const start = (page - 1) * PAGE_SIZE;
        const end = page * PAGE_SIZE - 1;
        getRouteSetterInfo(
            user,
            start,
            end,
            sortGyms,
            sortSectors,
            sortDifficulties,
            sortLevels,
            sortStatus,
            sortName,
            sortDate,
            filteredGyms,
            filteredDifficulties,
            filteredLevels,
            filteredTagsSteepness,
            filteredTagsGrips,
            filteredTagsStyle,
            filteredStatus,
            filteredSectors
        ).then(data => {
            setRoutesInfo({
                routes: [...data.routes],
                count: data.count
            });
            setDisableClick(false);
        });
        setCurrentPageNum(page);
    }

    const getPageNumbers = (): (number | '...')[] => {
        if (totalPages <= 7) {
            return Array.from({ length: totalPages }, (_, i) => i + 1);
        }
        const pages: (number | '...')[] = [1];
        if (currentPageNum > 3) pages.push('...');
        for (let i = Math.max(2, currentPageNum - 1); i <= Math.min(totalPages - 1, currentPageNum + 1); i++) {
            pages.push(i);
        }
        if (currentPageNum < totalPages - 2) pages.push('...');
        pages.push(totalPages);
        return pages;
    }

    useEffect(() => {
        document.title = "Back office"},
    [])

    // Unified data fetching — always server-side, resets to page 1 on filter/sort change
    useEffect(() => {
        if (!user || !currentGym) return;
        // Wait until status filter is initialized (clickedStatus has keys)
        if (Object.keys(clickedStatus).length === 0) return;

        setShouldBeLoading(true);
        setDisableClick(true);
        setCurrentPageNum(1);

        getRouteSetterInfo(
            user,
            0,
            PAGE_SIZE - 1,
            sortGyms,
            sortSectors,
            sortDifficulties,
            sortLevels,
            sortStatus,
            sortName,
            sortDate,
            filteredGyms,
            filteredDifficulties,
            filteredLevels,
            filteredTagsSteepness,
            filteredTagsGrips,
            filteredTagsStyle,
            filteredStatus,
            filteredSectors
        ).then(data => {
            setRoutesInfo({
                routes: [...data.routes],
                count: data.count
            });
            setTotalRoutesCount(data.count);
            setShouldBeLoading(false);
            setDisableClick(false);
        });
    }, [
        sortGyms,
        sortSectors,
        sortDifficulties,
        sortLevels,
        sortStatus,
        sortName,
        sortDate,
        filteredGyms,
        filteredTagsSteepness,
        filteredTagsGrips,
        filteredTagsStyle,
        filteredStatus,
        filteredDifficulties,
        filteredLevels,
        filteredSectors,
        user,
        currentGym,
        clickedStatus,
    ]);





    const handleGymClick = (gymId) => ( setDisableClick(true), handleItemClick(gymId, gymsFilterInfo, clickedGyms, setClickedGyms, checkGymAllFilters, setCheckGymAllFilters, setFilteredGyms, setRoutesInfo, true));
    const handleCheckGymsToggle = (status) => ( setDisableClick(true),handleCheckToggle(status, gymsFilterInfo, setClickedGyms, checkGymAllFilters, setCheckGymAllFilters, setFilteredGyms, setRoutesInfo, true));

    const handleDifficultyClick = (difficultyId) => ( setDisableClick(true),handleItemClick(difficultyId,difficultyList,clickedDifficulties,setClickedDifficulties,checkDifficultyAllFilters,setCheckDifficultyAllFilters,setFilteredDifficulties,setRoutesInfo, true))
    const handleCheckDifficultyToggle = (status) => ( setDisableClick(true),handleCheckToggle(status,difficultyList,setClickedDifficulties,checkDifficultyAllFilters,setCheckDifficultyAllFilters,setFilteredDifficulties,setRoutesInfo, true))

    const handleSectorClick = (sectorId) => ( setDisableClick(true),handleItemClick(sectorId,sectorsList,clickedSectors, setClickedSectors,checkSectorsAllFilters,setCheckSectorsAllFilters,setFilteredSectors,setRoutesInfo, true))
    const handleCheckSectorsToggle = (status) => ( setDisableClick(true),handleCheckToggle(status,sectorsList,setClickedSectors,checkSectorsAllFilters,setCheckSectorsAllFilters,setFilteredSectors,setRoutesInfo, true))

    const handleTagSteepnessClick = (tagId) => ( setDisableClick(true),handleItemClick(tagId,tagsList.tagSteepness,clickedTagsSteepness,setClickedTagsSteepness,checkTagsInclinaisonAllFilters,setCheckTagsInclinaisonAllFilters,setFilteredTagsSteepness,setRoutesInfo, true))
    const handleCheckSteepnessToggle = (status) => ( setDisableClick(true),handleCheckToggle(status, tagsList.tagSteepness,setClickedTagsSteepness,checkTagsInclinaisonAllFilters,setCheckTagsInclinaisonAllFilters,setFilteredTagsSteepness,setRoutesInfo, true))

    const handleTagGripsClick = (tagId) => ( setDisableClick(true),handleItemClick(tagId,tagsList.tagGrips,clickedTagsGrips,setClickedTagsGrips,checkTagsPrisesAllFilters,setCheckTagsPrisesAllFilters,setFilteredTagsGrips,setRoutesInfo, true))
    const handleCheckGripsToggle = (status) => ( setDisableClick(true),handleCheckToggle(status, tagsList.tagGrips, setClickedTagsGrips, checkTagsPrisesAllFilters,setCheckTagsPrisesAllFilters,setFilteredTagsGrips,setRoutesInfo, true))

    const handleTagStyleClick = (tagId) =>( setDisableClick(true), handleItemClick(tagId,tagsList.tagStyle,clickedTagsStyle,setClickedTagsStyle,checkTagsMovementAllFilters,setCheckTagsMovementAllFilters,setFilteredTagsStyle,setRoutesInfo, true))
    const handleCheckStyleToggle = (status) =>( setDisableClick(true), handleCheckToggle (status, tagsList.tagStyle, setClickedTagsStyle, checkTagsMovementAllFilters,setCheckTagsMovementAllFilters,setFilteredTagsStyle,setRoutesInfo, true))

    const handleStatusClick = (statusId) => ( setDisableClick(true),handleItemClick (statusId, statusList, clickedStatus,setClickedStatus,checkStatusAllFilters,setCheckStatusAllFilters,setFilteredStatus,setRoutesInfo, true))
    const handleCheckStatusToggle = (status) =>( setDisableClick(true),handleCheckToggle (status, statusList, setClickedStatus,checkStatusAllFilters,setCheckStatusAllFilters,setFilteredStatus,setRoutesInfo, true))

    const handleLevelClick = (levelId) =>( setDisableClick(true), handleItemClick (levelId, levelList, clickedLevels, setClickedLevels,checkLevelAllFilters,setCheckLevelAllFilters,setFilteredLevels,setRoutesInfo, true))
    const handleCheckLevelToggle = (status) => ( setDisableClick(true),handleCheckToggle (status, levelList, setClickedLevels, checkLevelAllFilters, setCheckLevelAllFilters,setFilteredLevels, setRoutesInfo, true))


    const handleGymSorting = () => { setDisableClick(true) ; handleSorting(sortGyms, setSortGyms, sortSetters) ;}
    const handleStatusSorting = () => {setDisableClick(true); handleSorting(sortStatus, setSortStatus, sortSetters);}
    const handleDifficultySorting = () => {setDisableClick(true); handleSorting(sortDifficulties,setSortDifficulties,sortSetters)}
    const handleSectorSorting = () => {setDisableClick(true) ; handleSorting(sortSectors,setSortSectors,sortSetters)}
    const handleNameSorting = () => {setDisableClick(true); handleSorting(sortName,setSortName,sortSetters)}
    const handleLevelSorting = () => {setDisableClick(true) ; handleSorting(sortLevels,setSortLevels,sortSetters)}
    const handleDateSorting = () => {setDisableClick(true) ; handleSorting(sortDate,setSortDate,sortSetters)}
    const handleColorSorting = () => {setDisableClick(true) ; handleSorting(sortColor,setSortColor,sortSetters)}




    useEffect(() => {
        if (user && currentGym) {
            getRouteSetterGymFilterInfoSpecific(user, currentGym.id).then(data => {
                setGymsFilterInfo(data)
                const allDifficulties = data.flatMap(gym => gym.difficultySystem);
                setDifficultyList(allDifficulties);
                const allSectors = data.flatMap(gym => gym.sectors);
                setSectorsList(allSectors);
                const difficultySystem = data[0].hasCustomDifficultySystem
                setAdditionnalDifficultySystem(difficultySystem)
                const allSummaryDifficulty = data.flatMap(gym => gym.summaryDifficulty);
                setDifficultySummary(allSummaryDifficulty);



            });

        } else {
            // Handle the case where user is not provided
            console.error("user not provided");
        }
    }, [user,currentGym]);



    useEffect(() => {
        const fetchTags = async () => {
            const tags = await getTagListInfo();
            setTagsList(tags);
        };

        fetchTags();
    }, []);

    useEffect(() => {
        if (gymsFilterInfo) {
            const initialGymState = gymsFilterInfo.reduce((acc, gym) => {
                acc[gym.id] = true;
                return acc;
            }, {});
            setClickedGyms(initialGymState);
        }
    }, [gymsFilterInfo]);

    useEffect(() => {
        if (statusList && statusList.length === 2) {
            const initialStatusState = {
                [statusList[0].id]: true,
                [statusList[1].id]: true
            };
            setClickedStatus(initialStatusState);
        }
    }, [gymsFilterInfo]);

    useEffect(() => {
        if (levelList) {
            const initialStatusState = levelList.reduce((acc, obj) => {
                acc[obj.id] = true;
                return acc;
            }, {});
            setClickedLevels(initialStatusState);
        }
    }, []);

    useEffect(() => {
        if (difficultyList) {
            const initialDifficultyState = difficultyList.reduce((acc, obj) => {
                acc[obj.id] = true;
                return acc;
            }, {});
            setClickedDifficulties(initialDifficultyState);
        }
    }, [difficultyList]);

    useEffect(() => {
        if (sectorsList) {
            const initialSectorsState = sectorsList.reduce((acc, obj) => {
                acc[obj.id] = true;
                return acc;
            }, {});
            setClickedSectors(initialSectorsState);
        }
    }, [sectorsList]);

    useEffect(() => {
        if (tagsList) {
            const initSteepness = {};
            tagsList.tagSteepness.forEach(tag => {
                initSteepness[tag.id] = true;
            });

            const initGrips = {};
            tagsList.tagGrips.forEach(tag => {
                initGrips[tag.id] = true;
            });

            const initStyle = {};
            tagsList.tagStyle.forEach(tag => {
                initStyle[tag.id] = true;
            });

            setClickedTagsSteepness(initSteepness);
            setClickedTagsGrips(initGrips);
            setClickedTagsStyle(initStyle);
        }
    }, [tagsList]);




    return (
    <div className='outerContainer'>
       <NavBarBackOffice
       profilePicture={routeSetterInfo?.picture}
        firstName={routeSetterInfo?.firstName}
        lastName={routeSetterInfo?.lastName}
        gyms={currentGym && currentGym.name}
        difficultySummary={difficultySummary}
        totalRoutesCount={totalRoutesCount}
        difficultySystem={hasAdditionnalDifficultySystem}
       />
       <div className="bo-main-content">
            <div className="bo-main-content__title">
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M23.6823 8.92495L16.556 4.60572C16.4549 4.53126 16.3286 4.48157 16.177 4.5065L6.34661 4.53126C6.16963 4.53126 5.99283 4.60572 5.86642 4.72988L0.231021 9.94285C0.0288315 10.1167 -0.0469677 10.3896 0.0288313 10.6626L2.6065 19.0034C2.70751 19.3012 2.98549 19.4998 3.28886 19.4998L19.3358 19.5C19.6138 19.5 19.8918 19.3261 19.9928 19.078L23.935 9.79397C24.0868 9.47121 23.9604 9.12368 23.6824 8.92505L23.6823 8.92495ZM8.29239 13.3436L16.4043 12.9216L18.3249 18.1097H4.70389L8.29239 13.3436ZM17.7942 12.5741L21.9638 10.8365L19.3863 16.8934L17.7942 12.5741ZM21.7618 9.4216L16.9857 11.4075L8.67154 5.92151L15.9748 5.89675L21.7618 9.4216ZM6.42244 6.12005L14.7365 11.6061L8.0145 11.9536L2.10113 10.1415L6.42244 6.12005ZM1.79788 11.5068L6.77623 13.021L3.56679 17.2658L1.79788 11.5068Z" fill="#1D5073"/>
                </svg>

                    <div className="bold large3" >
                        <p>Détail blocs</p>
                    </div>
            </div>

            {
                /*
                <div className="pannels-filter__pannel-selection">
                    <div className="large2 bold pannel-selection__library">
                        Bibliothèque
                    </div>
                    <div className="large2 light pannel-selection_route-setting">
                        Suivi ouvertures
                    </div>
                </div>
                */
            }
            <div className="pannels-filter__filters" style={!additionnalDifficultySystem ?{ width:'100%'} : {}}>
                {!areFiltersOpened &&
                    <div className='filter-header'>
                    <div className='filter-toggle bold large2'>
                        <CustomButton
                            text='Filtres'
                            onClickProp={()=>setAreFiltersOpened(true)}
                        />
                        <div className='filter-toggle bold lower2' style={{gap:'8px', paddingLeft:'12px',paddingRight:'12px'}}>
                            {!checkDifficultyAllFilters &&
                                <CustomButton
                                    text='Difficultés'
                                    customStyle='filter-card bold lower2'
                                    onClickProp={()=>{
                                        if (!disableClick) {
                                            handleCheckDifficultyToggle(!checkDifficultyAllFilters)
                                        }}}
                                />

                            }
                            {!checkLevelAllFilters &&
                                <CustomButton
                                    text='Niveau'
                                    customStyle='filter-card bold lower2'
                                    onClickProp={()=>{
                                        if (!disableClick) {
                                            handleCheckLevelToggle(!checkLevelAllFilters)
                                        }}}
                                />

                            }
                            {!checkSectorsAllFilters &&
                                <CustomButton
                                    text='Secteurs'
                                    customStyle='filter-card bold lower2'
                                    onClickProp={()=>{
                                        if (!disableClick) {
                                            handleCheckSectorsToggle(!checkSectorsAllFilters)
                                        }}}
                                />

                            }
                            {!checkTagsInclinaisonAllFilters &&
                                <CustomButton
                                    text='Tags : inclinaison'
                                    customStyle='filter-card bold lower2'
                                    onClickProp={()=>{
                                        if (!disableClick) {
                                            handleCheckSteepnessToggle(!checkTagsInclinaisonAllFilters)
                                        }}}
                                />

                            }
                            {!checkTagsPrisesAllFilters &&
                                <CustomButton
                                    text='Tags : prises'
                                    customStyle='filter-card bold lower2'
                                    onClickProp={()=>{
                                        if (!disableClick) {
                                            handleCheckGripsToggle(!checkTagsPrisesAllFilters)
                                        }}}
                                />

                            }
                            {!checkTagsMovementAllFilters &&
                                <CustomButton
                                    text='Tags : style'
                                    customStyle='filter-card bold lower2'
                                    onClickProp={()=>{
                                        if (!disableClick) {
                                            handleCheckStyleToggle(!checkTagsMovementAllFilters)
                                        }}}
                                />

                            }
                            {!checkStatusAllFilters &&
                                <CustomButton
                                    text='Statuts'
                                    customStyle='filter-card bold lower2'
                                    onClickProp={()=>{
                                        if (!disableClick) {
                                            handleCheckStatusToggle(!checkStatusAllFilters)
                                        }}}
                                />

                            }
                        </div>
                        <CustomButton
                            Svg={SVGs.bigChevronDown}
                            onClickProp={()=>setAreFiltersOpened(true)}
                        />
                    </div>

                </div>
                }
                {areFiltersOpened &&
                <>
                    <div className='filter-header'>
                        <div className='filter-toggle bold large2'>
                            <CustomButton
                                text='Filtres'
                                onClickProp={()=>setAreFiltersOpened(false)}
                            />
                            <div className='filter-toggle bold lower2' style={{gap:'8px', paddingLeft:'12px',paddingRight:'12px'}}>
                                {!checkDifficultyAllFilters &&
                                    <CustomButton
                                        text='Difficultés'
                                        customStyle='filter-card bold lower2'
                                        onClickProp={()=>{
                                            if (!disableClick) {
                                                handleCheckDifficultyToggle(!checkDifficultyAllFilters)
                                            }}}
                                    />

                                }
                                {!checkLevelAllFilters &&
                                    <CustomButton
                                        text='Niveau'
                                        customStyle='filter-card bold lower2'
                                        onClickProp={()=>{
                                            if (!disableClick) {
                                                handleCheckLevelToggle(!checkLevelAllFilters)
                                            }}}
                                    />

                                }
                                {!checkSectorsAllFilters &&
                                    <CustomButton
                                        text='Secteurs'
                                        customStyle='filter-card bold lower2'
                                        onClickProp={()=>{
                                            if (!disableClick) {
                                                handleCheckSectorsToggle(!checkSectorsAllFilters)
                                            }}}
                                    />

                                }
                                {!checkTagsInclinaisonAllFilters &&
                                    <CustomButton
                                        text='Tags : inclinaison'
                                        customStyle='filter-card bold lower2'
                                        onClickProp={()=>{
                                            if (!disableClick) {
                                                handleCheckSteepnessToggle(!checkTagsInclinaisonAllFilters)
                                            }}}
                                    />

                                }
                                {!checkTagsPrisesAllFilters &&
                                    <CustomButton
                                        text='Tags : prises'
                                        customStyle='filter-card bold lower2'
                                        onClickProp={()=>{
                                            if (!disableClick) {
                                                handleCheckGripsToggle(!checkTagsPrisesAllFilters)
                                            }}}
                                    />

                                }
                                {!checkTagsMovementAllFilters &&
                                    <CustomButton
                                        text='Tags : style'
                                        customStyle='filter-card bold lower2'
                                        onClickProp={()=>{
                                            if (!disableClick) {
                                                handleCheckStyleToggle(!checkTagsMovementAllFilters)
                                            }}}
                                    />

                                }
                                {!checkStatusAllFilters &&
                                    <CustomButton
                                        text='Statuts'
                                        customStyle='filter-card bold lower2'
                                        onClickProp={()=>{
                                            if (!disableClick) {
                                                handleCheckStatusToggle(!checkStatusAllFilters)
                                            }}}
                                    />

                                }
                            </div>
                            <CustomButton
                                Svg={SVGs.bigChevronUp}
                                onClickProp={()=>setAreFiltersOpened(false)}
                            />
                        </div>

                    </div>
                    <div style={{display:'flex', flexDirection:'row', gap:'16px'}}>

                        <div className='filter-selection-basic-for-2-filters'>
                            <div className="filter-selection-basic__difficulty">
                                <div className="light large">
                                    <h4 className="light normal">Difficulté</h4>
                                </div>
                                <div className="filter-selection__all-colors">
                                    <div className="all-filter" >
                                        <CheckMarkButton
                                            isChecked={checkDifficultyAllFilters}
                                            text={'Tout'}
                                            onToggle={()=>{
                                                if (!disableClick) {
                                                    handleCheckDifficultyToggle(!checkDifficultyAllFilters)
                                                }}}
                                            customStyle={`${disableClick ? 'bo-opacity' : 'selection-active'}`}
                                        />
                                    </div>
                                    <div className="boulders-color" data-category="color">
                                    {
                                        gymsFilterInfo && gymsFilterInfo.length > 0
                                        && gymsFilterInfo.flatMap(gym =>
                                            gym.difficultySystem.map(difficulty => (
                                                <DifficultySvg
                                                    key={difficulty.id}
                                                    isClicked={!!clickedDifficulties[difficulty.id]}
                                                    text={difficulty.id.toString()}
                                                    onClickProp={() =>{
                                                        if (!disableClick) {
                                                            handleDifficultyClick(difficulty.id)
                                                        }}}
                                                    svg={difficulty.svg}
                                                    hasDifficultySystem={additionnalDifficultySystem}
                                                    customStyle={`${disableClick ? 'bo-opacity' : 'selection-active'}`}
                                                />
                                            ))
                                        )

                                    }
                                    </div>
                                </div>
                            </div>
                            <div className="filter-selection-basic-2">
                                <div className='title-checkmark'>
                                    <div className="light large">
                                    <h4 className="light normal">Niveau</h4>
                                    </div>
                                    <div className="all-filter" >
                                        <CheckMarkButton
                                            isChecked={checkLevelAllFilters}
                                            text={'Tout'}
                                            onToggle={()=>{
                                                if (!disableClick) {
                                                    handleCheckLevelToggle(!checkLevelAllFilters)
                                                }}}
                                            customStyle={`${disableClick ? 'bo-opacity' : 'selection-active'}`}
                                        />
                                        </div>
                                </div>
                                <div className={`levels-display ${disableClick ? 'bo-opacity' : 'selection-active'}`} data-category="level">
                                {
                                    levelList.map(level => (
                                        <LevelSelector
                                            key={level.id}
                                            isClicked={!!clickedLevels[level.id]}
                                            text={level.id.toString()}
                                            onClickProp={() =>{
                                                if (!disableClick) {
                                                    handleLevelClick(level.id)
                                                }}}
                                            shouldShowFigure={true}
                                            customSize={[28,20]}

                                        />
                                    ))
                                }
                                </div>
                            </div>
                        </div>
                        <div className="filter-selection-extended">
                            <div className="light large">
                            <h4 className="light normal">Tags</h4>
                            </div>
                            <div className="filter-selection-extended__all-columns">
                                <div className="filter-selection-extended__column">
                                    <div className="lower2 bold">
                                        Inclinaison
                                    </div>
                                    <div className="all-filter" >
                                        <CheckMarkButton
                                            isChecked={checkTagsInclinaisonAllFilters}
                                            text={'Tout'}
                                            onToggle={()=>{
                                                if (!disableClick) {
                                                    handleCheckSteepnessToggle(!checkTagsInclinaisonAllFilters)
                                                }}}
                                            customStyle={`${disableClick ? 'bo-opacity' : 'selection-active'}`}
                                        />

                                    </div>
                                    <div className="vertical-toggles" data-category="steepness">
                                    {
                                        tagsList?.tagSteepness?.length > 0
                                        && tagsList.tagSteepness.map(tag => (
                                            <CustomButtonBO
                                                key={tag.id}
                                                isClicked={!!clickedTagsSteepness[tag.id]}
                                                text={tag.name}
                                                onClickProp={() =>{
                                                    if (!disableClick) {
                                                        handleTagSteepnessClick(tag.id)
                                                    }}}
                                                customStyle={`${disableClick ? 'bo-opacity' : 'selection-active'}`}
                                            />
                                        ))

                                    }
                                    </div>
                                </div>
                                <div className="filter-selection-extended__column" >
                                    <div className="lower2 bold">
                                        Prises
                                    </div>
                                    <div className="all-filter">
                                        <CheckMarkButton
                                            isChecked={checkTagsPrisesAllFilters}
                                            text={'Tout'}
                                            onToggle={()=>{
                                                if (!disableClick) {
                                                    handleCheckGripsToggle(!checkTagsPrisesAllFilters)
                                            }}}
                                            customStyle={`${disableClick ? 'bo-opacity' : 'selection-active'}`}
                                        />
                                    </div>
                                    <div className="vertical-toggles" data-category="holds">
                                    {
                                        tagsList?.tagGrips?.length > 0
                                        && tagsList.tagGrips.map(tag => (
                                            <CustomButtonBO
                                                key={tag.id}
                                                isClicked={!!clickedTagsGrips[tag.id]}
                                                text={tag.name}
                                                onClickProp={() =>{
                                                    if (!disableClick) {
                                                        handleTagGripsClick(tag.id)
                                                    }}}
                                                customStyle={`${disableClick ? 'bo-opacity' : 'selection-active'}`}
                                            />
                                        ))

                                    }
                                    </div>
                                </div>
                                <div className="filter-selection-extended__column">
                                    <div className="lower2 bold">
                                        Mouvement
                                    </div>
                                    <div className="all-filter" >
                                        <CheckMarkButton
                                            isChecked={checkTagsMovementAllFilters}
                                            text={'Tout'}
                                            onToggle={()=>{
                                                if (!disableClick) {
                                                    handleCheckStyleToggle(!checkTagsMovementAllFilters)
                                                }}}
                                            customStyle={`${disableClick ? 'bo-opacity' : 'selection-active'}`}
                                        />
                                    </div>
                                    <div className="vertical-toggles" data-category="movement">
                                    {
                                        tagsList?.tagStyle?.length > 0
                                        && tagsList.tagStyle.map(tag => (
                                            <CustomButtonBO
                                                key={tag.id}
                                                isClicked={!!clickedTagsStyle[tag.id]}
                                                text={tag.name}
                                                onClickProp={() =>{
                                                    if (!disableClick) {
                                                        handleTagStyleClick(tag.id)
                                                    }}}
                                                customStyle={`${disableClick ? 'bo-opacity' : 'selection-active'}`}
                                            />
                                        ))

                                    }
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className="filter-selection-basic__sector">
                            <div className="light large">
                            <h4 className="light normal">Secteurs</h4>
                            </div>
                            <div className="filter-selection__all-toggles__sector">
                                <div className="all-filter" >
                                    <CheckMarkButton
                                        isChecked={checkSectorsAllFilters}
                                        text={'Tout'}
                                        onToggle={()=>{
                                            if (!disableClick) {
                                                handleCheckSectorsToggle(!checkSectorsAllFilters)
                                            }}}
                                        customStyle={`${disableClick ? 'bo-opacity' : 'selection-active'}`}
                                    />
                                </div>
                                <div className="vertical-toggles__sector" data-category="sectors">
                                    {
                                        sectorsList.map(obj => (
                                            <CustomButtonBO
                                                key={obj.id}
                                                isClicked={!!clickedSectors[obj.id]}
                                                text={obj.name}
                                                onClickProp={() => {
                                                    if (!disableClick) {
                                                        handleSectorClick(obj.id)
                                                    }}}
                                                customStyle={`${disableClick ? 'bo-opacity' : 'selection-active'}`}
                                            />
                                        ))
                                    }
                                </div>
                            </div>
                        </div>
                        <div className='filter-selection-basic-for-2-filters'>
                            {/*
                            <div className="filter-selection-basic__gym">
                                <div className="light large">
                                    <h4>Mes salles</h4>
                                </div>
                                <div className={`filter-selection__all-toggles`}>
                                    <CheckMarkButton
                                        isChecked={checkGymAllFilters}
                                        text={'Tout'}
                                        onToggle={()=>{
                                            if (!disableClick) {
                                            handleCheckGymsToggle(!checkGymAllFilters)
                                        }}}
                                        customStyle={`${disableClick ? 'bo-opacity' : 'selection-active'}`}
                                    />
                                    <div className="vertical-toggles" data-category="gym">
                                    {
                                        gymsFilterInfo.length > 0
                                        ? gymsFilterInfo.map(gym => (
                                            <CustomButtonBO
                                                key={gym.id}
                                                isClicked={!!clickedGyms[gym.id]}
                                                text={gym.name}
                                                onClickProp={() =>{
                                                    if (!disableClick) {
                                                        handleGymClick(gym.id)
                                                    }}}
                                                customStyle={`${disableClick ? 'bo-opacity' : 'selection-active'}`}
                                            />
                                        ))
                                        : <div className="bold normal">No gyms found for this route setter.</div>
                                    }
                                    </div>
                                </div>
                            </div>
                            */}
                            <div className="filter-selection-basic-2">
                                <div className='title-checkmark'>
                                    <div className="light large">
                                    <h4 className="light normal">Statuts</h4>
                                    </div>
                                    <div className="all-filter" >
                                        <CheckMarkButton
                                            isChecked={checkStatusAllFilters}
                                            text={'Tout'}
                                            onToggle={()=>{
                                                if (!disableClick) {
                                                    handleCheckStatusToggle(!checkStatusAllFilters)
                                                }
                                            }}
                                            customStyle={`${disableClick ? 'bo-opacity' : 'selection-active'}`}
                                        />
                                    </div>
                                </div>
                                <div className={`filter-selection__all-toggles`}>
                                    <div className="vertical-toggles" data-category="status">
                                        { statusList.map(obj => (
                                                <CustomButtonBO
                                                    key={obj.id}
                                                    isClicked={!!clickedStatus[obj.id]}
                                                    text={obj.status}
                                                    onClickProp={() => {
                                                        if (!disableClick) {
                                                            handleStatusClick(obj.id)

                                                        }}}
                                                    customStyle={`${disableClick ? 'bo-opacity' : 'selection-active'}`}
                                                />
                                            ))
                                        }
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </>
                }
            </div>
            <div className='pannels-filter__filters animate-fadeIn' style={{gap:0, marginTop:'12px'}}>
                {/* */}
                <div className='filter-toggle bold large2'>{totalRoutesCount} blocs à parcourir</div>
                <div className='extended-row-title-container-route-summary-second-part-stats-portion-subtitle regular normal'>Clique sur un bloc pour accéder à ses statistiques</div>
                <div className={areFiltersOpened ? "main-content__boulders-library" : "main-content__boulders-library-filters-closed"}>
                    <div className={`boulders-library__table-header` }>
                        {/*
                            <CustomButtonSort
                                text='Salle'
                                Svg={sortGyms == 0 ? null : sortGyms == 1 ? SVGs.chevronDown : SVGs.chevronUp}
                                customStyle={`table-header__gyms large bold  ${disableClick ? 'bo-opacity' : 'selection-active'}`}
                                onClickProp={() => {
                                    if (!disableClick) {
                                    handleGymSorting()
                                    }
                                }}
                            />
                        */}
                        <CustomButtonSort
                            text='Nom'
                            Svg={sortName == 0 ? null : sortName == 1 ? SVGs.chevronDown : SVGs.chevronUp}
                            customStyle={additionnalDifficultySystem ? `table-header__boulders lower bold ${disableClick ? 'bo-opacity' : 'selection-active'}`:`table-header__boulders2 lower bold ${disableClick ? 'bo-opacity' : 'selection-active'}`}
                            onClickProp={() =>{
                                if (!disableClick) {
                                handleNameSorting()
                                }
                            }}
                        />
                        <CustomButtonSort
                            text='Secteur'
                            Svg={sortSectors == 0 ? null : sortSectors == 1 ? SVGs.chevronDown : SVGs.chevronUp}
                            customStyle={`table-header__sectors lower bold ${disableClick ? 'bo-opacity' : 'selection-active'}`}
                            onClickProp={() =>{
                                if (!disableClick) {
                                handleSectorSorting()
                                }
                            }}
                        />

                        {additionnalDifficultySystem &&
                            <div className={`table-header__colors1 lower bold ${disableClick ? 'bo-opacity' : 'selection-active'}`} >
                                Couleur
                            </div>
                        }
                        <CustomButtonSort
                            text='Difficulté'
                            Svg={sortDifficulties == 0 ? null : sortDifficulties == 1 ? SVGs.chevronDown : SVGs.chevronUp}
                            customStyle={additionnalDifficultySystem ? `table-header__colors lower bold ${disableClick ? 'bo-opacity' : 'selection-active'}` : `table-header__colors2 lower bold ${disableClick ? 'bo-opacity' : 'selection-active'}`}
                            onClickProp={() =>{
                                if (!disableClick) {
                                handleDifficultySorting()
                                }
                            }}
                        />
                        <CustomButtonSort
                            text='Niveau'
                            Svg={sortLevels == 0 ? null : sortLevels == 1 ? SVGs.chevronDown : SVGs.chevronUp}
                            customStyle={additionnalDifficultySystem ? `table-header__difficulty lower bold ${disableClick ? 'bo-opacity' : 'selection-active'}`: `table-header__difficulty2 lower bold ${disableClick ? 'bo-opacity' : 'selection-active'}`}
                            onClickProp={() =>{
                                if (!disableClick) {
                                handleLevelSorting()
                                }
                            }}
                        />
                    <CustomButtonSort
                            text='Ouverture'
                            Svg={sortDate == 0 ? null : sortDate == 1 ? SVGs.chevronDown : SVGs.chevronUp}
                            customStyle={`table-header__setting lower bold ${disableClick ? 'bo-opacity' : 'selection-active'}`}
                            onClickProp={() =>{
                                if (!disableClick) {
                                handleDateSorting()
                                }
                            }}
                        />
                        <div className={additionnalDifficultySystem ? `table-header__tags lower bold ${disableClick ? 'bo-opacity' : 'selection-active'}` : `table-header__tags2 lower bold ${disableClick ? 'bo-opacity' : 'selection-active'}`} data-sorted="-">
                            Tags
                        </div>
                        <div className={`table-header__status-info ${disableClick ? 'bo-opacity' : 'selection-active'}`} data-sorted="-">
                            <div className="lower bold">
                                Statut
                            </div>
                        </div>
                        <div className='table-header__empty-picture' ></div>
                    </div>
                    <div className="boulders_library__table-body" style={disableClick ? {opacity:0.3}:{opacity:1}}>
                        {shouldBeLoading && !routesInfo ? (
                            <BoulderTableSkeleton />
                        ) : routesInfo && routesInfo.routes && routesInfo.routes.length > 0 ? (
                            routesInfo.routes.map(route => (
                                <RouteRow
                                    key={route.id}
                                    route={route}
                                    difficultySystem={additionnalDifficultySystem}
                                    onClickProp={() => setAreFiltersOpened(false)}
                                />
                            ))
                        ) : (
                            !shouldBeLoading &&
                            <div className='no-routes-msg light large2'>
                                <div>Les filtres sélectionnés ne correspondent à aucun bloc</div>
                            </div>
                        )}
                        {totalPages > 1 && (
                            <div className='flex items-center justify-center gap-2 py-4 w-full'>
                                <button
                                    className={`pagination-btn ${currentPageNum === 1 ? 'bo-opacity' : 'selection-active'}`}
                                    onClick={() => goToPage(currentPageNum - 1)}
                                    disabled={currentPageNum === 1 || disableClick}
                                >
                                    &lt;
                                </button>
                                {getPageNumbers().map((page, idx) =>
                                    page === '...' ? (
                                        <span key={`dots-${idx}`} className="px-2 lower bold">...</span>
                                    ) : (
                                        <button
                                            key={page}
                                            className={`pagination-btn ${page === currentPageNum ? 'pagination-btn--active' : 'selection-active'}`}
                                            onClick={() => goToPage(page as number)}
                                            disabled={disableClick}
                                        >
                                            {page}
                                        </button>
                                    )
                                )}
                                <button
                                    className={`pagination-btn ${currentPageNum === totalPages ? 'bo-opacity' : 'selection-active'}`}
                                    onClick={() => goToPage(currentPageNum + 1)}
                                    disabled={currentPageNum === totalPages || disableClick}
                                >
                                    &gt;
                                </button>
                            </div>
                        )}
                    </div>
                </div>
            </div>
        </div>
    </div>

    );
}

export default BackOfficeMainPage;
